import React, { useRef, useState, useCallback } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import './SelectInputStyles.scss';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import Dropdown from '../../base/Dropdown/Dropdown';
import TextInput from '../TextInput/TextInput';
import renderMessage from '../renderMessage';
import { required } from '../../../utils/validation';
import CheckBoxInput from '../CheckBoxInput/CheckBoxInput';
import CheckBoxInputWithLabel from '../CheckBoxInput/CheckBoxInputWithLabel';

export default function MultipleSelectInput(props) {
  const {
    inputProps = null,
    className = '',
    options = [],
    fieldState = {
      error: '',
      touched: false,
    },
    controlId = `text-input-${Math.random() * 10000}`,
    variant = 'default',
    label,
    multiple = false,
    disabled = false,
    inputClassName = '',
    dtoObject,
    customValidator = [],
  } = props;
  const {
    error,
    isTouched: touched,
  } = fieldState;
  const intl = useIntl();
  const { formatMessage } = intl;
  const [toggleFunction, setToggleFunction] = useState(() => () => {});
  const anchorElement = useRef(null);
  const isError = Boolean(error);
  const value = inputProps && (inputProps.value || typeof inputProps.value === 'boolean') ? inputProps.value : [];

  const onChange = item => {
    if (inputProps && inputProps.onChange) {
      const newValue = [...value];
      const index = value.indexOf(item.value);
      if (index > -1) {
        newValue.splice(index, 1);
      } else {
        newValue.push(item.value);
      }
      inputProps.onChange({ target: { value: newValue, name: inputProps.name } });
    }
  };

  const selectedItems = options.filter(item => value.includes(item.value));
  const isRequired = (dtoObject
      && dtoObject.validators
      && dtoObject.validators.length
      && !!dtoObject.validators.find(validator => validator.toString() === required.toString()))
    || !!customValidator.find(validator => validator.toString() === required.toString());
  const isAll = options.every(o => value.includes(o.value));
  const isSome = options.some(o => value.includes(o.value)) && !isAll;
  return (
    <div className={classNames('form-control-wrapper', className)}>
      <Dropdown
        dropBottom
        usePortal
        disabled={disabled}
        setToggleFunction={a => setToggleFunction(() => a)}
      >
        <Dropdown.Toggle className="select-toggle">
          <div
            ref={anchorElement}
            className={classNames('form-control-wrapper multiple-select', className, { material: variant === 'material' }, { default: variant !== 'material' })}
          >
            <div className={classNames('input-block', { 'is-invalid': isError && touched })}>
              <div className="multiple-value-block">
                {selectedItems.map((item, index) => (
                  <div key={index} className="multiple-value">
                    {item.name}
                    <Icons
                      customIcon
                      className="multiple-value-delete"
                      width={24}
                      height={24}
                      icon="close"
                      onClick={event => {
                        onChange(item);
                        event.preventDefault();
                        event.stopPropagation();
                      }}
                    />
                  </div>
                ))}
              </div>
              <div htmlFor={props.id} className="form-input-label">
                {renderMessage(label)}{isRequired ? <span className="form-label-mark-required">*</span> : null}
              </div>
              <span className="input-after-block">
                <div className="select-arrow-wrapper">
                  <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
                </div>
              </span>
            </div>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu
          disableClickToggle={multiple}
          rightPadding={32}
          className="select-options-wrapper"
          anchorElement={anchorElement}
          classNamePortal="portal-select-options multiple-select-option"
        >
          <div className="select-options-list">
            <div
              className="select-option"
              onClick={() => {
                if (isAll) {
                  inputProps.onChange({ target: { value: [], name: inputProps.name } });
                } else {
                  inputProps.onChange({ target: { value: options.map(o => o.value), name: inputProps.name } });
                }
              }}
            >
              <CheckBoxInputWithLabel
                inputClassName={classNames({ 'some-child': isSome }, { 'every-child': isAll })}
                inputProps={{
                  value: isAll,
                  onChange: e => {},
                }}
                label={formatMessage({ id: 'select.all' })}
              />
            </div>
            {options.map((item, key) => {
              const isSelected = !!value.includes(item.value);
              return (
                <div
                  key={key}
                  className={classNames('select-option', { selected: isSelected })}
                  onClick={() => {
                    onChange(item);
                  }}
                >
                  <CheckBoxInputWithLabel
                    inputProps={{ value: isSelected, onChange: false }}
                    label={!item.name && item.nameId ? formatMessage({ id: item.nameId }) : item.name || ''}
                  />
                </div>
              );
            })}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
